var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEbay2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2072,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.359 21.68880147788684 251.28199999999998 282.31119852211316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.338 157.13a70.327 70.327 0 1 0-53.8 1.662l6.788-17.937a51.149 51.149 0 1 1 39.128-1.209z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.359 98.405h57.11V304h-39.11c-9.941 0-18-8.059-18-18z",
    fill: "#ea323c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.641 98.405h-57.109V304h39.109c9.941 0 18-8.059 18-18z",
    fill: "#88b621"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.531 98.405H126V304h68.531z",
    fill: "#f5ae03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126 98.405H57.468V304H126z",
    fill: "#0064d1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbay2);
export default __webpack_public_path__ + "static/media/ebay2.c52a48361cebab8eefef80724b81bcd4.svg";
export { ForwardRef as ReactComponent };